import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import TRANSLATIONS from '../translations/translations@default.json';

const useAprExamples = () => {
	const { products } = useSelector((_state) => _state);

	const {
		AprRepresentativeString,
		AprPurchaseRateString,
		RepresentativeAprSwitch24,
		PurchaseAprSwitch24,
		UseSwitch24,
	} = useSelector((state) => state.featureSwitches);

	const hasAtLeastOneSwitch24Product = useMemo(
		() =>
			Boolean(
				products?.find(
					(product) => product?.Switch24Pricing?.HasSwitch24 === true
				) ?? false
			),
		[products]
	);

	const showSwitch24Example = useMemo(
		() => UseSwitch24 && hasAtLeastOneSwitch24Product,
		[UseSwitch24, hasAtLeastOneSwitch24Product]
	);

	const financeRepExampleText = useMemo(
		() =>
			showSwitch24Example
				? TRANSLATIONS.listerFooter.financeExample
						.financeRepExampleWithSwitch24Title
				: TRANSLATIONS.listerFooter.financeExample.financeRepExampleTitle,
		[showSwitch24Example]
	);

	const aprRepresentative = useMemo(
		() =>
			UseSwitch24 && hasAtLeastOneSwitch24Product
				? RepresentativeAprSwitch24
				: AprRepresentativeString,
		[
			UseSwitch24,
			hasAtLeastOneSwitch24Product,
			RepresentativeAprSwitch24,
			AprRepresentativeString,
		]
	);

	const aprPurchaseRate = useMemo(
		() =>
			UseSwitch24 && hasAtLeastOneSwitch24Product
				? PurchaseAprSwitch24
				: AprPurchaseRateString,
		[
			UseSwitch24,
			hasAtLeastOneSwitch24Product,
			PurchaseAprSwitch24,
			AprPurchaseRateString,
		]
	);

	const aprRatesForProduct = useCallback(
		(colourId) => {
			const product = products?.find((p) => p.ColourId === colourId);

			if (!product) {
				return {};
			}

			const useSwitchRates =
				UseSwitch24 && product?.Switch24Pricing?.HasSwitch24 === true;

			return {
				aprRepresentative: useSwitchRates
					? RepresentativeAprSwitch24.toString()
					: AprRepresentativeString.toString(),
				aprPurchaseRate: useSwitchRates
					? PurchaseAprSwitch24.toString()
					: AprPurchaseRateString.toString(),
			};
		},
		[
			products,
			UseSwitch24,
			PurchaseAprSwitch24,
			AprPurchaseRateString,
			RepresentativeAprSwitch24,
			AprRepresentativeString,
		]
	);

	return {
		financeRepExampleText,
		showSwitch24Example,
		aprRepresentative,
		aprPurchaseRate,
		aprRatesForProduct,
	};
};

export default useAprExamples;
